module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Bold.97332a56.woff";